<div class="row">
    <div class="col-lg-12">
        <h5>My Metrics</h5>

        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    style="height: 479px"
                    (initialized)="grid.initialize(mainGrid)"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                    [itemFormatter]="goalsGridItemFormatter"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Metric'" [binding]="'name'" [width]="250" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="' '" [binding]="'goalDirection'" [width]="70" [align]="'center'" [isReadOnly]="true">
                        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                            {{ getGoalDirectionDisplay(cell.item) }}
                        </ng-template>
                    </wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Goal'"
                        [binding]="'goal1'"
                        [width]="120"
                        [align]="'center'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Average'"
                        [binding]="'average'"
                        [width]="100"
                        [align]="'center'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Sum'"
                        [binding]="'sum'"
                        [width]="120"
                        [align]="'center'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    @for (month of weekCols; track month) {
                        <wj-flex-grid-column
                            [binding]="'weekValues.' + month"
                            [align]="'center'"
                            [header]="month"
                            [width]="100"
                            [isReadOnly]="true"
                        >
                        </wj-flex-grid-column>
                    }
                </wj-flex-grid>
                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
            </div>
        </div>
    </div>
</div>
